import { Button, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Name = styled.div`
  display: inline-block;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

const TableNameButton = styled(Button)`
  gap: 8px;
  max-width: 100%;
  min-width: 0;
  width: 100%;

  ${({ onClick }) => {
    return !!onClick && 'cursor: pointer;';
  }}
`;

const TableNameText = styled(Typography)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;

  ${({ onClick }) => {
    return !!onClick && 'cursor: pointer;';
  }}
`;

export { Name, TableNameButton, TableNameText };
